import { render, staticRenderFns } from "./vSelectRubro.vue?vue&type=template&id=279a5124&scoped=true&"
import script from "./vSelectRubro.vue?vue&type=script&lang=js&"
export * from "./vSelectRubro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a5124",
  null
  
)

export default component.exports